import { defineStore } from 'pinia';
import { Project } from '../types/project';
import { Workspace } from '../types/workspace';
import { Step, StepType } from '../types/step';
import { ProjectVisibility } from '../types/project_visibility';
import { WorkspaceApi } from '../api/workspace';
import { ProjectApi } from '../api/project';
import TeamUser from '@/dashboard/types/teamUser';
import { CreateEditPopupType } from '@/dashboard/vue/components/popups/CreatePopupTabs/types';

type State = {
  showPopup: boolean;
  isCreate: boolean;
  project: Project | undefined | null;
  workspace: Workspace | undefined | null;
  step: StepType;
  tabs: CreateEditPopupType[];
};

export const useProjectAddAndEdit = defineStore('projectAddAndEdit', {
  state: (): State => ({
    showPopup: false,
    isCreate: true,
    workspace: null,
    project: null,
    step: Step.Name,
    tabs: [
      {
        title: 'Directory',
        step: Step.Name,
      },
      {
        title: 'Members',
        step: Step.Team,
      },
    ],
  }),
  getters: {},
  actions: {
    async create(name: string, allowPublic: boolean, team: TeamUser[], visibility: ProjectVisibility): Promise<Project | null | undefined> {
      if (!this.workspace) {
        return undefined;
      }

      const shortLink = this.workspace?.short_link;
      const result = await ProjectApi.create({ name, allowPublic, team, visibility, workspaceShortLink: shortLink });
      const project = result.project;

      if (project) {
        this.closePopup();
      }

      return project;
    },
    async edit(name: string, allowPublic: boolean, team: TeamUser[], visibility: ProjectVisibility): Promise<Project | null | undefined> {
      if (!this.project) {
        return undefined;
      }

      const shortLink = this.project?.short_link;
      const result = await ProjectApi.edit({ name, allowPublic, team, visibility, projectShortLink: shortLink });
      const project = result.project;

      if (project) {
        this.closePopup();
      }

      return project;
    },
    async loadWorkspace(id: number): Promise<Workspace | undefined | null> {
      const result = await WorkspaceApi.getById(id);
      return result.workspace;
    },
    async loadProject(shortLink: string): Promise<Project | undefined | null> {
      const result = await ProjectApi.getByShortLink(shortLink);
      return result.project;
    },
    setStep(step: StepType) {
      this.step = step;
    },
    openPopup(workspace: Workspace, project?: Project, step: StepType = Step.Name) {
      this.step = step;
      this.workspace = workspace;

      if (project) {
        this.isCreate = false;
        this.project = project;
      } else {
        this.isCreate = true;
        this.project = null;
      }

      this.showPopup = true;
    },
    closePopup() {
      this.showPopup = false;
      this.isCreate = false;
      this.workspace = null;
    },
  },
});
